import { render, staticRenderFns } from "./OsteopathyMaleBody.vue?vue&type=template&id=125e5cf8&"
import script from "./OsteopathyMaleBody.vue?vue&type=script&lang=js&"
export * from "./OsteopathyMaleBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports